// extracted by mini-css-extract-plugin
export default {"content":"WI","wrapper":"XI","gif":"YI","textContent":"ZI","gifContainer":"aJ","proteinGif":"bJ","counter_img":"cJ","usage-container":"eJ","usage-list":"fJ","checklist":"gJ","counter_title":"hJ","counter_wrapper":"iJ","active":"jJ","usage-counter":"kJ","line":"lJ"};
    if(module.hot) {
      // 1715091679819
      var cssReload = require("../../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  